import { IBulletin } from "@iloq/shared";
import React from "react";
import { Box, Text } from "@chakra-ui/react";
import "./bulletin-detail.css";
import { FormattedMessage } from "react-intl";

export function BulletinDetail({ bulletin }: { bulletin: IBulletin | undefined }): React.ReactNode {
  if (!bulletin) {
    return (
      <Text mt="4xl">
        <FormattedMessage id="bulletin.category.empty" />
      </Text>
    );
  }

  return (
    <Box
      maxW="100%"
      className={`bulletin_section bulletin_section--${bulletin.bulletin_category_slug}`}
    >
      <Box className="bulletin content">
        <Box
          className="bulletin-content content-area content-area--single post type-post status-publish format-standard hentry category-news"
          dangerouslySetInnerHTML={{ __html: bulletin.content }}
        />
      </Box>
    </Box>
  );
}
